import { generateLiveFilteredResourcesColumns } from "./generateLiveFilteredResourcesColumns";
import { getResourceTypeColumns } from "../../../../../../../../../../../account/components/resource-card/resource-card-content/resource-card-data/resource-card-grid/resouce-card-data-grid/utils/data-grid/columns-setup/getResourceTypeColumns";
import { ResourceType } from "../../../../../../../../../../../../../services/cloudchipr.api";
import { ColumnSetupType } from "../../../../../../../../../../../../../storybook/data-grid/utils/types/types";
import { ResourceItemType } from "../../../../../../../../../../../../../store/account/utils/types/types";
import { newMetricColumnsByFT } from "../../../../../../../../../../../account/components/resource-card/resource-card-content/resource-card-data/resource-card-grid/resouce-card-data-grid/cells/metrics-cells/utils/helpers/newMetricColumnsEnablenes";

export const getLiveFilteredResourcesColumns = (
  resourceType: ResourceType,
  options?: { includeFilterTemplate?: boolean; enableMetricsCharts?: boolean },
) => {
  const columns = getResourceTypeColumns(
    resourceType,
    newMetricColumnsByFT(options?.enableMetricsCharts),
  ) as ColumnSetupType<ResourceItemType>[];

  return generateLiveFilteredResourcesColumns(columns, options);
};
